module.exports = __webpack_public_path__ + "static/media/em-106.9833b1cf.png";